export default "./0a3424f1a2cc42d9637f8ab1f9d55733.svg";